import type { Step } from './types';
import type { VariationType } from '@/lib/types';

interface StepIndicatorProps {
  step: Step;
  variationType: VariationType;
}

export function StepIndicator({ step, variationType }: StepIndicatorProps) {
  const totalSteps = variationType === 'related' ? 2 : 3;
  const currentStepIndex = step === 'select_group' || step === 'create_group' || step === 'edit_group' ? 0
    : step === 'select_products' ? 1
    : 2;

  return (
    <div className="flex items-center justify-center gap-2 mb-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div key={index} className="flex items-center">
          <div
            className={`size-8 rounded-full flex items-center justify-center text-sm font-medium ${
              index <= currentStepIndex
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}
          >
            {index + 1}
          </div>
          {index < totalSteps - 1 && (
            <div
              className={`w-8 h-0.5 ${
                index < currentStepIndex ? 'bg-primary' : 'bg-muted'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}
